import { sendRankingDataIncremental } from "services/google-sheets.service";
import type { RankingDataDailyUpdate } from "types/send-ranking-data";


export function useSendRankingDataIncremental() {
  const handleSendRankingDataIncremental = async (payload: RankingDataDailyUpdate) => {
    try {
      const response = await sendRankingDataIncremental(payload);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return handleSendRankingDataIncremental;
}
